import { Box, BoxProps } from '@mui/material';

interface OnramperWidgetProps {
  url: string;
  title?: string;
}

export const OnramperWidget = ({ url, title = 'Onramper Widget', ...props }: OnramperWidgetProps & BoxProps) => {
  return (
    <Box width="100%" {...props}>
      <iframe
        src={url}
        title={title}
        allow="popups; accelerometer; autoplay; camera; gyroscope; payment; microphone"
        style={{
          width: '100%',
          height: '100%',
          border: 'none',
        }}
      />
    </Box>
  );
};
